import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { SettingsConstants } from 'projects/is-ui-kit/src/lib/core/settings/settings.service';
import { IsDeleteNoteService } from '../is-delete-note/is-delete-note.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { DateAdapter } from '@angular/material/core';
import { UntypedFormControl } from '@angular/forms';
import { QuillEditorComponent } from 'ngx-quill';
import moment from 'moment';
import { ExcelService } from './excel.service';
import { switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { queryParamsObjToString } from 'projects/is-ui-kit/src/lib/core/is-functions';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'lib-is-note-fullscreen-dialog',
  templateUrl: './is-note-fullscreen-dialog.component.html',
  styleUrls: ['./is-note-fullscreen-dialog.component.scss']
})
export class IsNoteFullscreenDialogComponent implements OnInit {

  public notesList: any;
  public notesListTotal: number = 0;
  public pageNotesList: number = 1;
  public showOthersButton: boolean = false;
  public showSpinner: boolean = false;

  public dataExperienceGeneralNotes: boolean = false;
  public dataExperienceInfo: any = {};
  public dataExperienceVersion: number = 1;

  @ViewChild('highlightedMenuTrigger') highlightedMenuTrigger: MatMenuTrigger;
  @ViewChild('generalMenuTrigger') generalMenuTrigger: MatMenuTrigger;
  public noteListGeneral: any = [];
  public noteListHighlighted: any = [];
  public authorList: any = [];
  public user: any = SettingsConstants.LOGGEDUSER;
  public highlightedNotes = this._translate.instant('highlighted_notes');
  public showAddNote: boolean = false;

  // quill-editor for view
  public quillConfigReadOnly = {
    toolbar: false
  };
  // quill-editor for new and edit
  @ViewChild('editEditor') editEditor: QuillEditorComponent;
  public quillConfig = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline']
      ]
    },
    mention: {
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      mentionDenotationChars: ['@'],
      defaultMenuOrientation: 'bottom',
      onSelect: (item, insertItem) => {
        const editor = this.editEditor.quillEditor;
        insertItem(item);
        editor.insertText(editor.getLength() - 1, '', 'user');
      },
      source: (searchTerm, renderList) => { // mention
        this.authorList = [];
        if (searchTerm !== '') {
          this.getAuthorsListMention(`${SettingsConstants.BACKENDURL}/inspiring/isauth/api/user/?search=${searchTerm}`, renderList, searchTerm);
        } else {
          this.getAuthorsListMention(`${SettingsConstants.BACKENDURL}/inspiring/isauth/api/user/`, renderList, searchTerm);
        }
      }
    }
  };

  constructor(
    private _dialog: MatDialogRef<IsNoteFullscreenDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _http: HttpClient,
    private _deleteNoteService: IsDeleteNoteService,
    private _translate: TranslateService,
    private _datePipe: DatePipe,
    private _dateAdapter: DateAdapter<Date>,
    private _excel: ExcelService,
    private _route: ActivatedRoute
  ) {
    this._dateAdapter.setLocale('en-GB'); // dd/MM/yyyy
  }

  ngOnInit(): void {
    this.dataExperienceGeneralNotes = this.data?.dataExperienceGeneralNotes;
    this.dataExperienceInfo = this.data?.dataExperienceInfo;
    this.dataExperienceVersion = this.data?.dataExperienceVersion;

    if (this.dataExperienceGeneralNotes && this.dataExperienceVersion === 1) {
      this.notesList = [];
      this.pageNotesList = 1;
      this.getGeneralDataExperienceV1Notes();
    }
    if (this.dataExperienceGeneralNotes === false && this.dataExperienceVersion === 1) {
      this.notesList = [];
      this.pageNotesList = 1;
      this.getFrameV1Notes(this.data?.dataExperienceInfo.frameId);
    }
  }

  // general notes
  public getGeneralDataExperienceV1Notes(queryParams: string = ''): void {
    this.showSpinner = true;
    let temp: any;
    const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/data_experience/${this.dataExperienceInfo.dataExperienceId}/notes/?exact_entity=${this.dataExperienceInfo.entity}&exact_entity_id=${this.dataExperienceInfo.entityID}&page=${this.pageNotesList}&valid_from=${this.dataExperienceInfo.dateFrom}&valid_to=${this.dataExperienceInfo.dateTo}`;
    this._http.get(url).subscribe({
      next: (data: any) => {
        temp = data;
      },
      error: (err: Error) => {
        console.error(err);
        this.showSpinner = false;
      },
      complete: () => {
        this.notesListTotal = temp.count;
        this.notesList = [...this.notesList, ...temp.results];
        if (temp.next !== null) {
          this.showOthersButton = true;
        }
        this.showSpinner = false;

        this.start();
      }
    });
  }

  // for frame notes
  public getFrameV1Notes(frameId): void {
    this.showSpinner = true;
    let temp: any;
    const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/frame/${frameId}/notes/?page=${this.pageNotesList}&valid_from=${this.dataExperienceInfo.dateFrom}&valid_to=${this.dataExperienceInfo.dateTo}`;
    this._http.get(url).subscribe({
      next: (data: any) => {
        temp = data;
      },
      error: (err: Error) => {
        console.error(err);
        this.showSpinner = false;
      },
      complete: () => {
        this.notesListTotal = temp.count;
        if (this.pageNotesList === 1) {
          this.notesList = temp.results;
        } else {
          this.notesList = [...this.notesList, ...temp.results];
        }
        if (temp.next !== null) {
          this.showOthersButton = true;
        } else {
          this.showOthersButton = false;
        }
        this.showSpinner = false;

        this.start();
      }
    });
  }

  public loadOthersGeneralNotes(event): void {
    this.showOthersButton = false;
    this.pageNotesList++;
    if (this.dataExperienceGeneralNotes && this.dataExperienceVersion === 1) {
      this.getGeneralDataExperienceV1Notes();
    }
    if (this.dataExperienceGeneralNotes === false && this.dataExperienceVersion === 1) {
      this.getFrameV1Notes(this.data?.dataExperienceInfo.frameId);
    }
  }

  public start(): void {
    this.noteListHighlighted = [];
    this.noteListGeneral = [];
    this.notesList.forEach((note) => {
      note['dateFrom'] = new UntypedFormControl(null);
      note['timeFrom'] = new UntypedFormControl('00:00');
      note['dateTo'] = new UntypedFormControl(null);
      note['timeTo'] = new UntypedFormControl('23:59');
      note['note'] = false;
      note['newText'] = '';
      if (note.valid_from !== null && note.valid_from !== undefined) {
        const time = this.extractTime(note.valid_from);
        note['dateFrom'].setValue(note.valid_from);
        note['timeFrom'].setValue(time);
        note['valid_from_formatted'] = this.getFormattedDate(note.valid_from);
      }
      if (note.valid_to !== null && note.valid_to !== undefined) {
        const time = this.extractTime(note.valid_to);
        note['dateTo'].setValue(note.valid_to);
        note['timeTo'].setValue(time);
        note['valid_to_formatted'] = this.getFormattedDate(note.valid_to);
      }
      note['creation_datetime_formatted'] = this.getFormattedDate(note.creation_datetime);
      note['update_datetime_formatted'] = this.getFormattedDate(note.update_datetime);
      if (note?.pinned === true) {
        this.noteListHighlighted.push(note);
      } else {
        this.noteListGeneral.push(note);
      }
    });
  }

  public getAuthorsListMention(url, renderList, searchTerm): void {
    this.authorList = [];
    this._http.get(url).pipe(
      switchMap((data: any) => {
        this.authorList = data.results.map((author: any) => ({
          id: author.id,
          value: author?.str || author?.first_name + ' ' + author?.last_name
        }));

        return of(this.authorList);
      }),
      catchError((error: Error) => {
        console.error(error);
        return of([]); // Return an empty array if there's an error
      })
    ).subscribe((data: any) => {
      renderList(data, searchTerm);
    });
  }

  public extractTime(dateTimeStr: string): any {
    const originalDateTime = new Date(dateTimeStr);
    const hours = originalDateTime.getHours();
    const minutes = originalDateTime.getMinutes();
    // const seconds = originalDateTime.getSeconds();
    // const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
    return formattedTime;
  }

  public getFormattedDate(originalDate): string {
    const date = new Date(originalDate);
    return this._datePipe.transform(date, 'dd/MM/yyyy HH:mm') || '';
  }

  // prevent matMenu closing
  public preventPanelClosing(event: any): void {
    event.stopPropagation();
  }

  public addNewNote(): void {
    this.showAddNote = true;
  }

  public closeShowAddNote(event): void {
    this.showAddNote = false;
  }

  public exportNoteList(event): void {
    let params = {};
    if (this._route.snapshot.queryParams) {
      params = _.cloneDeep(this._route.snapshot.queryParams);
    }
    params['request_format'] = 'excel';
    let idsList = [];
    idsList = this.notesList.map((el) => el.id);
    let queryParams = '?' + queryParamsObjToString(params);
    if (idsList.length !== 0) {
      queryParams = queryParams + '&ids=[' + idsList.join(',') + ']';
    }
    const url = `${SettingsConstants.HOST_NAME}${'/api/dataxp/v1/notes/'}${queryParams}`;
    window.open(url);
  }

  public getCurrentDateTime(): string {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year}_${hours}:${minutes}`;
  }

  public removeMarkupFromString(htmlString: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body.textContent || '';
  }

  public closeFullscreeNoteList(event): void {
    this._dialog.close();
  }

  public createNewGeneralNote(note): void {
    this.showAddNote = false;
    if (this.dataExperienceGeneralNotes) {
      note['entity'] = 'dataxp';
      note['entity_id'] = this.dataExperienceInfo.dataExperienceId;
      note['exact_entity'] = this.dataExperienceInfo.entity;
      note['exact_entity_id'] = this.dataExperienceInfo.entityID;
    } else {
      note['entity'] = 'dataxpframe';
      note['entity_id'] = this.dataExperienceInfo.frameId;
      note['exact_entity'] = null;
      note['exact_entity_id'] = null;
    }
    const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/notes/`;
    this.showSpinner = true;
    this._http.post(url, note).subscribe({
      next: (data) => {
        this.showSpinner = false;
        this.notesList.push(data);
        this.start();
      },
      error: (err: Error) => {
        console.error(err);
        this.showSpinner = false;
      },
      complete: () => {
      }
    });
  }

  // SINGLE NOTE ACTIONS
  public changeHighlighted(note): void {
    if (this.dataExperienceGeneralNotes) {
      const obj = {
        pinned: !note.pinned,
        entity: note.entity,
        entity_id: note.entity_id
      };

      this.apiEdit(obj, note.id);
    }
  }

  public changeRefferedTo(note, newReffered): void {
    if (this.dataExperienceGeneralNotes) {
      const obj = {
        entity: newReffered
      };
      if (obj.entity === 'dataxp') {
        obj['entity_id'] = this.dataExperienceInfo.dataExperienceId;
      } else if (obj.entity === 'site') {
        obj['entity_id'] = this.dataExperienceInfo.entityID;
      }

      this.apiEdit(obj, note.id);
    }
  }

  public apiEdit(obj, noteId): void {
    this.showSpinner = true;
    const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/notes/${noteId}/`;
    this._http.put(url, obj).subscribe({
      next: (data) => {
        this.showSpinner = false;
        const index = this.notesList.findIndex((not) => not.id === noteId);
        if (index !== -1) {
          this.notesList.splice(index, 1, data);
          this.start();
        }
      },
      error: (err: Error) => {
        console.error(err);
        this.showSpinner = false;
      },
      complete: () => {
      }
    });
  }

  public editNote(event, note): void {
    event.stopPropagation();
    if (this.highlightedMenuTrigger?.menuOpen) {
      this.highlightedMenuTrigger.closeMenu();
    }
    if (this.generalMenuTrigger?.menuOpen) {
      this.generalMenuTrigger.closeMenu();
    }
    note.isEdit = true;
    note.newText = note.text;
  }

  public deleteNote(event, note): void {
    event.stopPropagation();
    if (this.highlightedMenuTrigger?.menuOpen) {
      this.highlightedMenuTrigger.closeMenu();
    }
    if (this.generalMenuTrigger?.menuOpen) {
      this.generalMenuTrigger.closeMenu();
    }
    this._deleteNoteService.openDeleteNoteDialog(note, (result: any) => {
      if (result) {
        const url = `${SettingsConstants.BACKENDURL}/api/dataxp/v1/notes/${note.id}/`;
        this.showSpinner = true;
        this._http.delete(url).subscribe({
          next: (data) => {
            this.showSpinner = false;
            const index = this.notesList.findIndex((not) => not.id === note.id);
            if (index !== -1) {
              delete this.notesList[index];
              this.start();
            }
          },
          error: (err: Error) => {
            console.error(err);
            this.showSpinner = false;
          },
          complete: () => {
          }
        });
      }
    });
  }

  public setSubmitDisabled(note): boolean {
    if (note.newText === '') {
      return true;
    } else {
      return false;
    }
  }

  public submit(event, note): void {
    let finalFromDate: string = null;
    if (note.dateFrom.value !== null) {
      let tempTimeFrom = '00:00';
      if (note.timeFrom.value !== '' && note.timeFrom.value !== null && note.timeFrom.value !== undefined) {
        tempTimeFrom = note.timeFrom.value;
      }
      const timeFromTemp = moment(tempTimeFrom, 'hmm').format('HH:mm') !== 'Invalid date' ? moment(tempTimeFrom, 'hmm').format('HH:mm') : tempTimeFrom;
      finalFromDate = this.convertDateTime(note.dateFrom.value, timeFromTemp);
    }
    let finalToDate: string = null;
    if (note.dateTo.value !== null) {
      let tempTimeTo = '23:59';
      if (note.timeTo.value !== '' && note.timeTo.value !== null && note.timeTo.value !== undefined) {
        tempTimeTo = note.timeTo.value;
      }
      const timeToTemp = moment(tempTimeTo, 'hmm').format('HH:mm') !== 'Invalid date' ? moment(tempTimeTo, 'hmm').format('HH:mm') : tempTimeTo;
      finalToDate = this.convertDateTime(note.dateTo.value, timeToTemp);
    }
    const newNote = {
      id: note.id,
      text: note.newText,
      valid_from: finalFromDate,
      valid_to: finalToDate,
      entity: note.entity,
      entity_id: note.entity_id
    };
    note.isEdit = false;

    this.apiEdit(newNote, note.id);
  }

  public convertDateTime(dateString: string, timeString: string): string {
    const originalDate = new Date(dateString);
    const day = originalDate.getDate();
    const month = originalDate.getMonth() + 1;
    const year = originalDate.getFullYear();
    const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
    const desiredDateTimeStr = `${formattedDate}T${timeString}:00`;
    return desiredDateTimeStr;
  }

  public cancel(event, note): void {
    this.noteListGeneral.forEach((not) => {
      if (not.id === note.id) {
        note.isEdit = false;
        note.newText = '';
        note.dateFrom.setValue(note.valid_from);
        note.dateTo.setValue(note.valid_to);
        note.timeFrom.setValue('00:00');
        note.timeTo.setValue('23:59');
      }
    });
    this.noteListHighlighted.forEach((not) => {
      if (not.id === note.id) {
        note.isEdit = false;
        note.newText = '';
        note.dateFrom.setValue(note.valid_from);
        note.dateTo.setValue(note.valid_to);
        note.timeFrom.setValue('00:00');
        note.timeTo.setValue('23:59');
      }
    });
  }

  public checkPermission(permissions: string | string[]): boolean {
    if (typeof (permissions) === 'string') {
      if (SettingsConstants.USERPERMISSIONS[permissions]) {
        return SettingsConstants.USERPERMISSIONS[permissions];
      } else {
        return false;
      }
    } else {
      for (let i = 0; i < permissions.length; i++) {
        if (!(permissions[i] in SettingsConstants.USERPERMISSIONS)) {
          return false;
        }
      }
      return true;
    }
  }
}
